import livingModernMinimalist from '../../../assets/img/quiz/living/modern-minimalist.jpg';
import livingMidCentury from '../../../assets/img/quiz/living/mid-century.jpg';
import livingVibrantOriental from '../../../assets/img/quiz/living/vibrant-oriental.jpg';
import livingIndustrial from '../../../assets/img/quiz/living/industrial.jpg';
import livingScandinavian from '../../../assets/img/quiz/living/scandinavian.jpg';
import livingFarmhouse from '../../../assets/img/quiz/living/farmhouse.jpg';
import livingBohemian from '../../../assets/img/quiz/living/bohemian.jpg';
import livingArtDeco from '../../../assets/img/quiz/living/art-deco.jpg';

import diningModernMinimalist from '../../../assets/img/quiz/dining/modern-minimalist.jpg';
import diningMidCentury from '../../../assets/img/quiz/dining/mid-century.webp';
import diningVibrantOriental from '../../../assets/img/quiz/dining/vibrant-oriental.jpg';
import diningIndustrial from '../../../assets/img/quiz/dining/industrial.jpg';
import diningScandinavian from '../../../assets/img/quiz/dining/scandinavian.avif';
import diningFarmhouse from '../../../assets/img/quiz/dining/farmhouse.jpg';
import diningBohemian from '../../../assets/img/quiz/dining/bohemian.jpg';
import diningArtDeco from '../../../assets/img/quiz/dining/art-deco.jpg';

import officeModernMinimalist from '../../../assets/img/quiz/office/modern-minimalist.jpg';
import officeMidCentury from '../../../assets/img/quiz/office/mid-century.jpg';
import officeVibrantOriental from '../../../assets/img/quiz/office/vibrant-oriental.jpg';
import officeIndustrial from '../../../assets/img/quiz/office/industrial.jpg';
import officeScandinavian from '../../../assets/img/quiz/office/scandinavian.jpg';
import officeFarmhouse from '../../../assets/img/quiz/office/farmhouse.jpg';
import officeBohemian from '../../../assets/img/quiz/office/bohemian.jpg';
import officeArtDeco from '../../../assets/img/quiz/office/art-deco.jpg';

import lightModernMinimalist from '../../../assets/img/quiz/light/modern-minimalist.jpg';
import lightMidCentury from '../../../assets/img/quiz/light/mid-century.png';
import lightVibrantOriental from '../../../assets/img/quiz/light/vibrant-oriental.jpg';
import lightIndustrial from '../../../assets/img/quiz/light/industrial.jpg';
import lightScandinavian from '../../../assets/img/quiz/light/scandinavian.jpg';
import lightFarmhouse from '../../../assets/img/quiz/light/farmhouse.jpg';
import lightBohemian from '../../../assets/img/quiz/light/bohemian.jpg';
import lightArtDeco from '../../../assets/img/quiz/light/art-deco.jpg';

export const questions = [
  {
    id: 1,
    question: "Living Space",
    options: [
      {
        text: "Clean lines, functional furniture, and a focus on simplicity",
        image: livingModernMinimalist,
        weights: {
          "Modern Minimalist": 2,
          "Scandinavian/ Japanese Elegance": 1
        }
      },
      {
        text: "Warm wood tones, vintage pieces, and mid-century inspired furniture",
        image: livingMidCentury,
        weights: {
          "Mid Century Modern": 2,
          "Modern Farmhouse": 1
        }
      },
      {
        text: "Rich colors, ornate patterns, and eclectic decorative elements",
        image: livingVibrantOriental,
        weights: {
          "Vibrant Oriental": 2,
          "Contemporary Bohemian": 1
        }
      },
      {
        text: "Raw materials, exposed elements, and urban-inspired design",
        image: livingIndustrial,
        weights: {
          "Industrial Loft": 2,
          "Art Deco - Collectors Heaven": 1
        }
      },
      {
        text: "Natural materials, minimalist aesthetic, and zen-like atmosphere",
        image: livingScandinavian,
        weights: {
          "Scandinavian/ Japanese Elegance": 2,
          "Modern Minimalist": 1
        }
      },
      {
        text: "Rustic charm, farmhouse elements, and cozy comfort",
        image: livingFarmhouse,
        weights: {
          "Modern Farmhouse": 2,
          "Mid Century Modern": 1
        }
      },
      {
        text: "Bold patterns, artistic elements, and free-spirited design",
        image: livingBohemian,
        weights: {
          "Contemporary Bohemian": 2,
          "Vibrant Oriental": 1
        }
      },
      {
        text: "Geometric patterns, luxurious materials, and dramatic accents",
        image: livingArtDeco,
        weights: {
          "Art Deco - Collectors Heaven": 2,
          "Industrial Loft": 1
        }
      }
    ]
  },
  {
    id: 2,
    question: "Dining Space",
    options: [
      {
        text: "Sleek dining table, minimalist chairs, and clean tableware",
        image: diningModernMinimalist,
        weights: {
          "Modern Minimalist": 2,
          "Scandinavian/ Japanese Elegance": 1
        }
      },
      {
        text: "Vintage dining set, retro lighting, and classic tableware",
        image: diningMidCentury,
        weights: {
          "Mid Century Modern": 2,
          "Modern Farmhouse": 1
        }
      },
      {
        text: "Colorful table settings, ornate centerpieces, and traditional elements",
        image: diningVibrantOriental,
        weights: {
          "Vibrant Oriental": 2,
          "Contemporary Bohemian": 1
        }
      },
      {
        text: "Industrial-style table, metal chairs, and raw material accents",
        image: diningIndustrial,
        weights: {
          "Industrial Loft": 2,
          "Art Deco - Collectors Heaven": 1
        }
      },
      {
        text: "Natural wood table, simple tableware, and peaceful ambiance",
        image: diningScandinavian,
        weights: {
          "Scandinavian/ Japanese Elegance": 2,
          "Modern Minimalist": 1
        }
      },
      {
        text: "Farmhouse table, rustic chairs, and country-style decor",
        image: diningFarmhouse,
        weights: {
          "Modern Farmhouse": 2,
          "Mid Century Modern": 1
        }
      },
      {
        text: "Eclectic mix of chairs, artistic tableware, and unique centerpieces",
        image: diningBohemian,
        weights: {
          "Contemporary Bohemian": 2,
          "Vibrant Oriental": 1
        }
      },
      {
        text: "Elegant dining set, crystal glassware, and geometric patterns",
        image: diningArtDeco,
        weights: {
          "Art Deco - Collectors Heaven": 2,
          "Industrial Loft": 1
        }
      }
    ]
  },
  {
    id: 3,
    question: "Office Space",
    options: [
      {
        text: "Clean desk setup, minimal decor, and organized storage",
        image: officeModernMinimalist,
        weights: {
          "Modern Minimalist": 2,
          "Scandinavian/ Japanese Elegance": 1
        }
      },
      {
        text: "Vintage desk, retro office accessories, and warm lighting",
        image: officeMidCentury,
        weights: {
          "Mid Century Modern": 2,
          "Modern Farmhouse": 1
        }
      },
      {
        text: "Colorful stationery, decorative elements, and cultural artifacts",
        image: officeVibrantOriental,
        weights: {
          "Vibrant Oriental": 2,
          "Contemporary Bohemian": 1
        }
      },
      {
        text: "Industrial desk, metal storage, and exposed elements",
        image: officeIndustrial,
        weights: {
          "Industrial Loft": 2,
          "Art Deco - Collectors Heaven": 1
        }
      },
      {
        text: "Natural wood desk, simple organization, and peaceful atmosphere",
        image: officeScandinavian,
        weights: {
          "Scandinavian/ Japanese Elegance": 2,
          "Modern Minimalist": 1
        }
      },
      {
        text: "Rustic desk, farmhouse storage, and cozy workspace",
        image: officeFarmhouse,
        weights: {
          "Modern Farmhouse": 2,
          "Mid Century Modern": 1
        }
      },
      {
        text: "Creative workspace, artistic elements, and unique organization",
        image: officeBohemian,
        weights: {
          "Contemporary Bohemian": 2,
          "Vibrant Oriental": 1
        }
      },
      {
        text: "Elegant desk, luxury accessories, and geometric patterns",
        image: officeArtDeco,
        weights: {
          "Art Deco - Collectors Heaven": 2,
          "Industrial Loft": 1
        }
      }
    ]
  },
  {
    id: 4,
    question: "Light",
    options: [
      {
        text: "Clean, bright lighting with minimal fixtures",
        image: lightModernMinimalist,
        weights: {
          "Modern Minimalist": 2,
          "Scandinavian/ Japanese Elegance": 1
        }
      },
      {
        text: "Warm, vintage-inspired lighting with retro fixtures",
        image: lightMidCentury,
        weights: {
          "Mid Century Modern": 2,
          "Modern Farmhouse": 1
        }
      },
      {
        text: "Colorful lighting, decorative lamps, and cultural elements",
        image: lightVibrantOriental,
        weights: {
          "Vibrant Oriental": 2,
          "Contemporary Bohemian": 1
        }
      },
      {
        text: "Industrial lighting, exposed bulbs, and metal fixtures",
        image: lightIndustrial,
        weights: {
          "Industrial Loft": 2,
          "Art Deco - Collectors Heaven": 1
        }
      },
      {
        text: "Natural light, simple fixtures, and peaceful ambiance",
        image: lightScandinavian,
        weights: {
          "Scandinavian/ Japanese Elegance": 2,
          "Modern Minimalist": 1
        }
      },
      {
        text: "Rustic lighting, farmhouse fixtures, and warm glow",
        image: lightFarmhouse,
        weights: {
          "Modern Farmhouse": 2,
          "Mid Century Modern": 1
        }
      },
      {
        text: "Artistic lighting, unique fixtures, and creative elements",
        image: lightBohemian,
        weights: {
          "Contemporary Bohemian": 2,
          "Vibrant Oriental": 1
        }
      },
      {
        text: "Elegant lighting, crystal fixtures, and dramatic effects",
        image: lightArtDeco,
        weights: {
          "Art Deco - Collectors Heaven": 2,
          "Industrial Loft": 1
        }
      }
    ]
  }
]; 